import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = '#pricing'
}: CTAButtonProps) {
  const content = <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`relative w-full group overflow-hidden rounded-xl bg-gold-gradient p-[2px] shadow-gold-glow ${className}`} data-id="element-102">
      <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-103" />
      <div className="relative flex items-center justify-center gap-2 bg-gradient-to-r from-[#b8902c] via-[#d4af37] to-[#b8902c] px-6 py-4 rounded-[10px] text-brand-dark font-montserrat font-bold text-lg md:text-xl uppercase tracking-wide" data-id="element-104">
        {children}
        <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-105" />
      </div>
    </motion.button>;
  if (href) {
    return <a href={href} className="block w-full no-underline" data-id="element-106">
        {content}
      </a>;
  }
  return content;
}